module.exports = __webpack_public_path__ + "static/img/sport-talk-bubble-message.667ef9e.png";